import component from './component.js'
import Vue from 'vue'

const vr = (msg, el) => {
  const PromptConstructor = Vue.extend(component)
  const position = getElPosition(el)
  const a = new PromptConstructor({
    propsData: {
      position,
      message: msg
    }
  })
  let span = document.createElement('span')
  span.className = 'error-tips'
  $(el).after(span)
  a.$mount('.error-tips')
}

function getElPosition(el) {
  if (window.getComputedStyle && ($(el)[0].parentNode && !$(el)[0].parentNode.style.position)) {
    const _position = window.getComputedStyle($(el)[0].parentNode).position
    if (!_position || _position === 'static') {
      $(el)[0].parentNode.style.position = 'relative'
    }
  }
  return {
    top: $(el)[0].offsetTop-22,
    left: $(el)[0].offsetLeft
  }
}

export default vr


// WEBPACK FOOTER //
// ./src/verify/tip.js